/**
 * @generated SignedSource<<eb95ba49ee05e46854ec0f269674bd64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AvatarFragment$data = {
  readonly avatar: {
    readonly blurhash: string | null | undefined;
    readonly icon: string;
    readonly small: string;
  } | null | undefined;
  readonly handle: string;
  readonly " $fragmentType": "AvatarFragment";
};
export type AvatarFragment$key = {
  readonly " $data"?: AvatarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AvatarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AvatarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "handle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "GraphQLMediaImage",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "small",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blurhash",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "IGraphQLProfile",
  "abstractKey": "__isIGraphQLProfile"
};

(node as any).hash = "f77a6317ba6544c1b7c216be1cf4ba93";

export default node;
